<template>
  <div class="openingReport">
    <div class="cont-box">
      <div class="classTitle">
        <Title text="开题报告" :isShowBack="true" />
      </div>
      <div>
        <el-form
              ref="search"
              :inline="true"
              :model="condition"
              :rules="searchRules"
              class="search-form"
              slot="search"
              label-width="80px"
          >
              <div style="display: flex; justify-content: space-between">
                  <div>

                  </div>
                  <div>
                    <div class="btn-box">
                      <div>
                        <el-form-item>
                          <el-button type="primary" @click="proposalClick">填写开题报告</el-button>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
              </div>
          </el-form>
      </div>
      <div class="graduation-tab">
        <el-table
            :data="list"
            headerRowClassName="uni-primary-table-header"
            stripe
            border
          >
            <el-table-column prop="title" align="center" label="标题" min-width="120"></el-table-column>
            <el-table-column prop="teacher_opinion" align="center" label="老师意见" min-width="120"></el-table-column>
            <el-table-column prop="agree_open" align="center" label="是否同意开题" min-width="120">
                <template slot-scope="{row}">
                  <span>{{ row.agree_open == 1 ? '是' : '否' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="review_status" align="center" label="审核状态" min-width="120">
                <template slot-scope="{row}">
                    <el-tag :type="row.review_status | reviewStatusStyleFilter">{{ row.review_status | reviewStatusFilter }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" align="center" label="提交时间" min-width="120"></el-table-column>
            <el-table-column align="center" label="操作" width="200">
              <template slot-scope="{row}">
                    <el-button class="link-btn" type="text" @click="seeProposal(row)">查看</el-button>
                    <el-button v-if="row.review_status == 1" class="link-btn" type="text" @click="proposalPDF(row)">导出PDF</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
    </div>
    <!-- 填写开题报告 -->
    <el-dialog
      class="assignment proposal"
      title=""
      :visible.sync="isShowProposal"
      width="900px"
      :close-on-click-modal="false"
      @close="proposalClose"
    >
      <div class="cont">
        <el-form
          ref="proposalRef"
          :model="proposalData"
          :rules="proposalRules"
          label-position="left"
        >
          <div class="floor border-b">
            <p class="cont-title">毕业论文（设计）开题报告</p>
          </div>
          <div class="floor border-b info-box">
            <div class="item border-r">
              <span class="name">姓名：</span>
              <span class="value">{{ studentInfo.student_title }}</span>
            </div>
            <div class="item border-r">
              <span class="name">学号：</span>
              <span class="value">{{ studentInfo.student_code }}</span>
            </div>
            <div class="item">
              <span class="name">指导教师：</span>
              <span class="value">{{ studentInfo.teacher_title }}</span>
            </div>
          </div>
          <div class="floor border-b info-box">
            <div class="item border-r">
              <span class="name">学院：</span>
              <span class="value">{{ studentInfo.school_title }}</span>
            </div>
            <div class="item border-r">
              <span class="name">专业：</span>
              <span class="value">{{ studentInfo.profession_title }}</span>
            </div>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title required">题目：</p>
            <el-form-item label="" prop="title">
              <el-input
                type="textarea"
                v-model="proposalData.title"
                placeholder="请输入题目"
                :rows="4"
                :maxlength="500"
                resize="none"
                show-word-limit
                :readonly="isShowProposalSubmit"
              ></el-input>
            </el-form-item>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title required"> 一、选题背景：</p>
            <el-form-item label="" prop="content">
              <el-input
                type="textarea"
                v-model="proposalData.background"
                placeholder="备注：简介选题的基本概念、理论或应用背景，明确主要工作内容、工作目标、预期成果，简要说明选题对专业知识、能力综合训练的情况。"
                :rows="4"
                resize="none"
                show-word-limit
                :readonly="isShowProposalSubmit"
              ></el-input>
            </el-form-item>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title required">二、国内外现状：</p>
            <el-form-item label="" prop="now_situation">
              <el-input
                type="textarea"
                v-model="proposalData.now_situation"
                placeholder="备注：学生针对毕业设计（论文）选题所涉及的研究与应用领域，进行广泛地文献查询，在阅读理解、综合分析的基础上总结凝练，应包含自己的客观归纳评述内容，不能仅仅是文献成果的简单堆砌（文献引用处要在句末用“[ ]”上标注明文献出处），应着重说明选题紧密相关的国内现状、国外现状、主要问题与发展趋势。"
                :rows="4"
                resize="none"
                show-word-limit
                :readonly="isShowProposalSubmit"
              ></el-input>
            </el-form-item>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title required">三、主要内容：</p>
            <el-form-item label="" prop="main_content">
              <el-input
                type="textarea"
                v-model="proposalData.main_content"
                placeholder="备注：简要说明具体的工作内容和拟解决的重点难点问题，由学院根据不同类型的选题，明确具体的内容和要求。"
                :rows="4"
                resize="none"
                show-word-limit
                :readonly="isShowProposalSubmit"
              ></el-input>
            </el-form-item>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title required">四、方案与计划：</p>
            <el-form-item label="" prop="plan_content">
              <el-input
                type="textarea"
                v-model="proposalData.plan_content"
                placeholder="备注：1.方案，简要说明研究方法、分析思路、技术路线等，如有重点难点问题，说明拟解决办法。2.进度计划，列出时间安排及相应工作内容。以上2点由学院根据不同类型的选题，明确具体的内容和要求。"
                :rows="4"
                resize="none"
                show-word-limit
                :readonly="isShowProposalSubmit"
              ></el-input>
            </el-form-item>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title required"> 五、主要参考文献：</p>
            <el-form-item label="" prop="reference">
              <el-input
                type="textarea"
                v-model="proposalData.reference"
                placeholder="备注：列出最主要参考文献。"
                :rows="4"
                resize="none"
                show-word-limit
                :readonly="isShowProposalSubmit"
              ></el-input>
            </el-form-item>
          </div>
          <div class="floor border-b table">
            <div class="table-cont">
              <table class="table-box">
                <tr>
                  <th class="cell" colspan="5">开题纪要</th>
                </tr>
                <tr>
                  <td class="cell time required">时间</td>
                  <td class="cell time-value">
                    <el-form-item prop="open_time">
                      <el-input v-model="proposalData.open_time" :readonly="isShowProposalSubmit" placeholder=""></el-input>
                    </el-form-item>
                  </td>
                  <td class="cell required">地点</td>
                  <td class="cell" colspan="2">
                    <el-form-item prop="open_place">
                      <el-input v-model="proposalData.open_place" :readonly="isShowProposalSubmit" placeholder=""></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td class="cell required">参与人员</td>
                  <td class="cell" colspan="4">
                    <el-form-item prop="open_participant">
                      <el-input v-model="proposalData.open_participant" :readonly="isShowProposalSubmit" placeholder=""></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr class="cell">
                  <td class="cell required">
                    <p>开</p>
                    <p>题</p>
                    <p>工</p>
                    <p>作</p>
                    <p>记</p>
                    <p>录</p>
                  </td>
                  <td class="cell" colspan="4">
                    <div>
                      <el-form-item prop="work_record">
                        <el-input
                          type="textarea"
                          v-model="proposalData.work_record"
                          placeholder="备注：详细说明开题情况。"
                          :rows="4"
                          resize="none"
                          show-word-limit
                          :readonly="isShowProposalSubmit"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="floor-bot">
                      <el-form-item label="学生签名：" prop="student_sign_img">
                        <el-image
                            v-if="isShowProposalSubmit"
                            class="see-img"
                            :src="proposalData.student_sign_img"
                        >
                        </el-image>
                        <esignHandle
                          v-else
                          ref="esignHandle4"
                          :selectSignImg.sync="proposalData.student_sign_img"
                          @selectSignImgAfter="studentSignImgAfter($event, 'proposalRef', 'student_sign_img')"
                        ></esignHandle>
                      </el-form-item>
                      <el-form-item label="" prop="student_sign_date">
                        <div class="date-box required">
                          <span class="text value">{{ proposalData.studentSignDate.year }}</span>
                          <!-- <el-input class="input" v-model="proposalData.studentSignDate.year" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                          <span class="text">年</span>
                          <span class="text value">{{ proposalData.studentSignDate.month }}</span>
                          <!-- <el-input class="input" v-model="proposalData.studentSignDate.month" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                          <span class="text">月</span>
                          <span class="text value">{{ proposalData.studentSignDate.day }}</span>
                          <!-- <el-input class="input" v-model="proposalData.studentSignDate.day" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                          <span class="text">日</span>
                        </div>
                      </el-form-item>
                    </div>
                  </td>
                </tr>
                <tr class="cell">
                  <!-- required -->
                  <td class="cell">
                    <p>指</p>
                    <p>导</p>
                    <p>教</p>
                    <p>师</p>
                    <p>意</p>
                    <p>见</p>
                  </td>
                  <td class="cell" colspan="4">
                    <div>
                      <el-form-item prop="teacher_opinion">
                        <!-- <div style="height: 100px;"></div> -->
                        <el-input
                            type="textarea"
                            v-model="proposalData.teacher_opinion"
                            placeholder="备注：对学生的开题报告做全面做评价，明确是否同意开题。"
                            :rows="4"
                            :maxlength="500"
                            resize="none"
                            show-word-limit
                            readonly
                            ></el-input>
                      </el-form-item>
                    </div>
                    <div class="radio-box">
                      <el-form-item prop="agree_open">
                        <el-radio-group v-model="proposalData.agree_open" :disabled="true">
                          <el-radio :label="1">同意开题</el-radio>
                          <el-radio :label="0">不同意开题</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                    <div class="floor-bot">
                      <el-form-item label="教师签名：" prop="teacher_sign_img">
                        <el-image
                            v-if="isShowProposalSubmit && !!proposalData.teacher_sign_img"
                            class="see-img"
                            :src="proposalData.teacher_sign_img"
                        >
                        </el-image>
                        <!-- <esignHandle
                            ref="esignHandle1"
                            :selectSignImg.sync="proposalData.student_sign_img"
                            @selectSignImgAfter="studentSignImgAfter($event, 'proposalRef', 'student_sign_img')"
                        ></esignHandle> -->
                      </el-form-item>
                      <el-form-item label="" prop="teacher_sign_date">
                        <div class="date-box">
                          <span class="text value">{{ proposalData.teacherSignDate.year }}</span>
                          <!-- <el-input class="input" v-model="proposalData.studentSignDate.year" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                          <span class="text">年</span>
                          <span class="text value">{{ proposalData.teacherSignDate.month }}</span>
                          <!-- <el-input class="input" v-model="proposalData.studentSignDate.month" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                          <span class="text">月</span>
                          <span class="text value">{{ proposalData.teacherSignDate.day }}</span>
                          <!-- <el-input class="input" v-model="proposalData.studentSignDate.day" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                          <span class="text">日</span>
                        </div>
                      </el-form-item>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </el-form>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="isShowProposal = false">关闭</el-button>
        <el-button v-if="!isShowProposalSubmit" type="primary" @click="proposalSubmit">确认提交</el-button>
      </div>
    </el-dialog>
    <!-- 开题报告PDF -->
    <el-dialog
      class="assignment proposal"
      title=""
      :visible.sync="isShowProposalPDF"
      width="900px"
      :close-on-click-modal="false"
      @close="proposalClose"
    >
      <div ref="proposalRefPDF" class="proposalPDF-box">
          <div class="assignment-pdf-cover">
            <div class="title-box">
              <p class="title1">重庆医科大学</p>
              <p class="title2">成人高等教育</p>
              <p class="title2">毕业论文（设计）开题报告</p>
            </div>
            <div class="cover-box">
              <div class="item">
                <p class="name">
                  <span class="text">题</span>
                  <span class="text">目：</span>
                </p>
                <p class="value">{{ proposalData.title }}</p>
              </div>
              <div class="item">
                <p class="name">
                  <span class="text">学</span>
                  <span class="text">院：</span>
                </p>
                <p class="value">继续教育学院</p>
              </div>
              <div class="item">
                <p class="name">
                  <span class="text">专</span>
                  <span class="text">业：</span>
                </p>
                <p class="value">{{ studentInfo.profession_title }}</p>
              </div>
              <div class="item">
                <p class="name">
                  <span class="text">学</span>
                  <span class="text">生</span>
                  <span class="text">姓</span>
                  <span class="text">名：</span>
                </p>
                <p class="value">{{ studentInfo.student_title }}</p>
              </div>
              <div class="item">
                <p class="name">
                  <span class="text">学</span>
                  <span class="text">号：</span>
                </p>
                <p class="value">{{ studentInfo.student_code }}</p>
              </div>
              <div class="item">
                <p class="name">
                  <span class="text">指</span>
                  <span class="text">导</span>
                  <span class="text">老</span>
                  <span class="text">师：</span>
                </p>
                <p class="value">{{ studentInfo.teacher_title }}</p>
              </div>
            </div>
          </div>
          <div class="proposalPDF">
            <el-form
              ref="proposalRef"
              :model="proposalData"
              :rules="proposalRules"
              label-position="left"
            >
              <div class="floor border-b textarea">
                <p class="item-title"> 一、选题背景：</p>
                <el-form-item label="" prop="content">
                  <p style="padding: 5px 15px;white-space: pre-wrap;">{{ proposalData.background }}</p>
                  <!-- <el-input
                    type="textarea"
                    v-model="proposalData.background"
                    placeholder="备注：简介选题的基本概念、理论或应用背景，明确主要工作内容、工作目标、预期成果，简要说明选题对专业知识、能力综合训练的情况。"
                    :rows="4"
                    resize="none"
                    show-word-limit
                    :readonly="isShowProposalSubmit"
                  ></el-input> -->
                </el-form-item>
              </div>
              <div class="floor border-b textarea">
                <p class="item-title">二、国内外现状：</p>
                <el-form-item label="" prop="now_situation">
                  <p style="padding: 5px 15px;white-space: pre-wrap;">{{ proposalData.now_situation }}</p>
                  <!-- <el-input
                    type="textarea"
                    v-model="proposalData.now_situation"
                    placeholder="备注：学生针对毕业设计（论文）选题所涉及的研究与应用领域，进行广泛地文献查询，在阅读理解、综合分析的基础上总结凝练，应包含自己的客观归纳评述内容，不能仅仅是文献成果的简单堆砌（文献引用处要在句末用“[ ]”上标注明文献出处），应着重说明选题紧密相关的国内现状、国外现状、主要问题与发展趋势。"
                    :rows="4"
                    resize="none"
                    show-word-limit
                    :readonly="isShowProposalSubmit"
                  ></el-input> -->
                </el-form-item>
              </div>
              <div class="floor border-b textarea">
                <p class="item-title">三、主要内容：</p>
                <el-form-item label="" prop="main_content">
                  <p style="padding: 5px 15px;white-space: pre-wrap;">{{ proposalData.main_content }}</p>
                  <!-- <el-input
                    type="textarea"
                    v-model="proposalData.main_content"
                    placeholder="备注：简要说明具体的工作内容和拟解决的重点难点问题，由学院根据不同类型的选题，明确具体的内容和要求。"
                    :rows="4"
                    resize="none"
                    show-word-limit
                    :readonly="isShowProposalSubmit"
                  ></el-input> -->
                </el-form-item>
              </div>
              <div class="floor border-b textarea">
                <p class="item-title">四、方案与计划：</p>
                <el-form-item label="" prop="plan_content">
                  <p style="padding: 5px 15px;white-space: pre-wrap;">{{ proposalData.plan_content }}</p>
                  <!-- <el-input
                    type="textarea"
                    v-model="proposalData.plan_content"
                    placeholder="备注：1.方案，简要说明研究方法、分析思路、技术路线等，如有重点难点问题，说明拟解决办法。2.进度计划，列出时间安排及相应工作内容。以上2点由学院根据不同类型的选题，明确具体的内容和要求。"
                    :rows="4"
                    resize="none"
                    show-word-limit
                    :readonly="isShowProposalSubmit"
                  ></el-input> -->
                </el-form-item>
              </div>
              <div class="floor border-b textarea">
                <p class="item-title"> 五、主要参考文献：</p>
                <el-form-item label="" prop="reference">
                  <p style="padding: 5px 15px;white-space: pre-wrap;">{{ proposalData.reference }}</p>
                  <!-- <el-input
                    type="textarea"
                    v-model="proposalData.reference"
                    placeholder="备注：列出最主要参考文献。"
                    :rows="4"
                    resize="none"
                    show-word-limit
                    :readonly="isShowProposalSubmit"
                  ></el-input> -->
                </el-form-item>
              </div>
              <div class="floor border-b table">
                <div class="table-cont">
                  <table class="table-box">
                    <tr>
                      <th class="cell" colspan="5">开题纪要</th>
                    </tr>
                    <tr>
                      <td class="cell time">时间</td>
                      <td class="cell time-value">
                        {{ proposalData.open_time }}
                        <!-- <el-form-item prop="open_time">
                          <el-input v-model="proposalData.open_time" :readonly="isShowProposalSubmit" placeholder=""></el-input>
                        </el-form-item> -->
                      </td>
                      <td class="cell">地点</td>
                      <td class="cell" colspan="2">
                        {{ proposalData.open_place }}
                        <!-- <el-form-item prop="open_place">
                          <el-input v-model="proposalData.open_place" :readonly="isShowProposalSubmit" placeholder=""></el-input>
                        </el-form-item> -->
                      </td>
                    </tr>
                    <tr>
                      <td class="cell">参与人员</td>
                      <td class="cell left" colspan="4">
                        {{ proposalData.open_participant }}
                        <!-- <el-form-item prop="open_participant">
                          <el-input v-model="proposalData.open_participant" :readonly="isShowProposalSubmit" placeholder=""></el-input>
                        </el-form-item> -->
                      </td>
                    </tr>
                    <tr class="cell">
                      <td class="cell">
                        <p>开</p>
                        <p>题</p>
                        <p>工</p>
                        <p>作</p>
                        <p>记</p>
                        <p>录</p>
                      </td>
                      <td class="cell left" colspan="4">
                        <div>
                          <p style="padding: 5px 15px;white-space: pre-wrap;">{{ proposalData.work_record }}</p>
                          <!-- <el-form-item prop="work_record">
                            <el-input
                              type="textarea"
                              v-model="proposalData.work_record"
                              placeholder="备注：详细说明开题情况。"
                              :rows="4"
                              resize="none"
                              show-word-limit
                              :readonly="isShowProposalSubmit"
                            ></el-input>
                          </el-form-item> -->
                        </div>
                        <div class="floor-bot">
                          <el-form-item label="学生签名：">
                            <el-image
                                :src="proposalData.student_sign_img"
                                style="width: 50px; height: 50px;"
                            >
                            </el-image>
                          </el-form-item>
                          <el-form-item label="" prop="student_sign_date">
                            <div class="date-box">
                              <span class="text value">{{ proposalData.studentSignDate.year }}</span>
                              <!-- <el-input class="input" v-model="proposalData.studentSignDate.year" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                              <span class="text">年</span>
                              <span class="text value">{{ proposalData.studentSignDate.month }}</span>
                              <!-- <el-input class="input" v-model="proposalData.studentSignDate.month" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                              <span class="text">月</span>
                              <span class="text value">{{ proposalData.studentSignDate.day }}</span>
                              <!-- <el-input class="input" v-model="proposalData.studentSignDate.day" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                              <span class="text">日</span>
                            </div>
                          </el-form-item>
                        </div>
                      </td>
                    </tr>
                    <tr class="cell">
                      <!-- required -->
                      <td class="cell">
                        <p>指</p>
                        <p>导</p>
                        <p>教</p>
                        <p>师</p>
                        <p>意</p>
                        <p>见</p>
                      </td>
                      <td class="cell left" colspan="4">
                        <div>
                          <p style="padding: 5px 15px;white-space: pre-wrap;">{{ proposalData.teacher_opinion }}</p>
                          <!-- <el-form-item prop="teacher_opinion">
                            <div style="height: 100px;"></div>
                            <el-input
                                type="textarea"
                                v-model="proposalData.teacher_opinion"
                                placeholder="备注：对学生的开题报告做全面做评价，明确是否同意开题。"
                                :rows="4"
                                :maxlength="500"
                                resize="none"
                                show-word-limit
                                readonly
                                ></el-input>
                          </el-form-item> -->
                        </div>
                        <div class="radio-box">
                          <el-form-item prop="agree_open">
                            <el-radio-group v-model="proposalData.agree_open" :disabled="true">
                              <el-radio :label="1">同意开题</el-radio>
                              <el-radio :label="0">不同意开题</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="floor-bot">
                          <el-form-item label="教师签名：" prop="teacher_sign_img">
                            <el-image
                                style="width: 50px; height: 50px;"
                                :src="proposalData.teacher_sign_img"
                            >
                            </el-image>
                            <!-- <esignHandle
                                ref="esignHandle1"
                                :selectSignImg.sync="proposalData.student_sign_img"
                                @selectSignImgAfter="studentSignImgAfter($event, 'proposalRef', 'student_sign_img')"
                            ></esignHandle> -->
                          </el-form-item>
                          <el-form-item label="" prop="teacher_sign_date">
                            <div class="date-box">
                              <span class="text value">{{ proposalData.teacherSignDate.year }}</span>
                              <!-- <el-input class="input" v-model="proposalData.studentSignDate.year" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                              <span class="text">年</span>
                              <span class="text value">{{ proposalData.teacherSignDate.month }}</span>
                              <!-- <el-input class="input" v-model="proposalData.studentSignDate.month" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                              <span class="text">月</span>
                              <span class="text value">{{ proposalData.teacherSignDate.day }}</span>
                              <!-- <el-input class="input" v-model="proposalData.studentSignDate.day" placeholder="" @input="inputChange($event, 'student_sign_date', 'proposalData', 'studentSignDate')"></el-input> -->
                              <span class="text">日</span>
                            </div>
                          </el-form-item>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </el-form>
          </div>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="isShowProposalPDF = false">关闭</el-button>
        <el-button @click="proposalExportPDF">导出PDF</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPaperApi } from "@/api/basic";

import {deepClone, goFirstError} from '@/utils/func';

import { putObject, uploadFiles, deleteObject } from "@/utils/upload";
import esignHandle from '@/components/esignHandle';

import {
    studentPpsInfo,
    getReportList,
    studentSubmitReport,
    studentGetReport,
} from "@/api/graduation";

import html2pdf from 'html2pdf.js'

export default {
  name: "openingReport",
  components: {esignHandle},
  data() {
    return {
      paper_plan_student_id: this.$route.query.paper_plan_student_id,
      condition: {},
      searchRules: {},
      list:[],
      listTotal: -1,

      // 学生详情
      studentInfo: {
        student_title: '',  //学生姓名
        teacher_title: '',  //指导老师姓名
        teacher_mobile: '',  //指导老师电话
        is_degree: '',  //是否需要学位 0否 1是
        is_sign: '',  //是否报名 0否 1是
        is_declaration: '',  //是否提交声明 0否 1是
        is_statement: '',  //是否提交任务书 0否 1是
        is_report: '',  //是否提交开题报告 0否 1是
        is_one: '',  //一稿状态 0未提交 1已提交
        is_two: '',  //二稿状态 0未提交 1已提交
        is_three: '',  //三稿状态 0未提交 1已提交
        is_defence_apply: '',  //答辩申请 0未提交 1已提交
        is_score_reply: '',  //成绩申请 0未提交 1已提交
        sign_deadline: '',  //毕设报名截止时间
        report_deadline: '',  //任务开题截止时间
        one_deadline: '',  //一稿上传截止时间
        two_deadline: '',  //二稿上传截止时间
        three_deadline: '',  //三稿上传截止时间
        defense_reply_deadline: '',  //答辩申请截止时间
        cross_deadline: '',  //交叉评阅截止时间
        defense_deadline: '',  //毕设答辩截止时间
        score_reply_deadline: '',  //成绩申请截止时间
        step: '',  //步骤
      },

      // 填写开题报告
      isShowProposal: false,
      proposalData: {
        paper_plan_student_id: '',  //学生毕业设计及答辩id
        title: '',  //题目
        background: '',  //选题背景
        now_situation: '',  //国内外现状
        main_content: '',  //主要内容
        plan_content: '',  //方案与计划
        reference: '',  //参考文献
        open_time: '',  //开题时间
        open_place: '',  //开题地点
        open_participant: '',  //开题参与人员
        work_record: '',  //工作记录
        student_sign_img: '',  //学生手写签名
        student_sign_date: '',  //学生手写签名日期
        studentSignDate: {
          year: '',  //签名日期 年
          month: '',  //签名日期 月
          day: '',  //签名日期 日
        },
        agree_open: '',  //是否同意开题 0否 1是
        teacher_opinion: '',  //指导老师意见
        teacher_sign_img: '',  //指导老师手写签名
        teacher_sign_date: '',  //指导老师手写签名日期
        teacherSignDate: {
            year: '',  //签名日期 年
            month: '',  //签名日期 月
            day: '',  //签名日期 日
        },
      },
      proposalRules: {
        title: [{required: true, trigger: 'blur', message: "请输入题目"}],
        background: [{required: true, trigger: 'blur', message: "请输入选题背景"}],
        now_situation: [{required: true, trigger: 'blur', message: "请输入国内外现状"}],
        main_content: [{required: true, trigger: 'blur', message: "请输入主要内容"}],
        plan_content: [{required: true, trigger: 'blur', message: "请输入方案与计划"}],
        reference: [{required: true, trigger: 'blur', message: "请输入主要参考文献"}],
        open_time: [{required: true, trigger: 'blur', message: "请输入开题时间"}],
        open_place: [{required: true, trigger: 'blur', message: "请输入开题地点"}],
        open_participant: [{required: true, trigger: 'blur', message: "请输入开题参与人员"}],
        work_record: [{required: true, trigger: 'blur', message: "请输入开题工作记录"}],
        student_sign_img: [{required: true, trigger: 'blur', message: "请添加学生签名"}],
        student_sign_date: [{required: true, trigger: 'blur', message: "请输入签名日期"}],
      },

      // 开题报告PDF
      isShowProposalPDF: false,
      // 查看提交的开题报告
      isShowProposalSubmit: false,
      
    };
  },
  filters:{
    // 审核状态
    reviewStatusFilter(v){
      const obj = {
        0: '待审核',
        1: '同意',
        2: '不同意',
      };
      return obj[v];
    },
    reviewStatusStyleFilter(v){
        const obj = {
        0: 'success',
        1: 'success',
        2: 'danger',
      };
      return obj[v];
    },
  },
  created() {
    this.getStudentPpsInfoData();
    this.getListFn();
  },
  methods: {
    // 开题报告 导出PDF
    proposalExportPDF(){
      const opt = {
        margin: 0.5,
        filename: '开题报告.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
      }
      html2pdf().set(opt).from(this.$refs.proposalRefPDF).save();
    },
    // 开题报告 PDF
    proposalPDF(row){
        const data = {
            id: row.id,
        };
      this.getProposalData(data).then(res => {
        this.isShowProposalPDF = true;
      });
    },
    // 查看开题报告
    seeProposal(row){
        const data = {
            id: row.id,
        };
      this.getProposalData(data).then(res => {
        this.isShowProposalSubmit = true;
        this.isShowProposal = true;
      });
    },
    // 获取开题报告
    getProposalData(data){
      return new Promise((resolve,reject) => {
        studentGetReport(data).then(res => {
          if (res.code === 200) {
            const {
              paper_plan_student_id,  //学生毕业设计及答辩id
              title,  //题目
              background,  //选题背景
              now_situation,  //国内外现状
              main_content,  //主要内容
              plan_content,  //方案与计划
              reference,  //参考文献
              open_time,  //开题时间
              open_place,  //开题地点
              open_participant,  //开题参与人员
              work_record,  //工作记录
              student_sign_img,  //学生手写签名
              student_sign_date,  //学生手写签名日期
              // studentSignDate: {
              //     year: '',  //签名日期 年
              //     month: '',  //签名日期 月
              //     day: '',  //签名日期 日
              // },
              agree_open,  //是否同意开题 0否 1是
              teacher_opinion,  //指导老师意见
              teacher_sign_img,  //指导老师手写签名
              teacher_sign_date,  //指导老师手写签名日期
              // teacherSignDate: {
              //     year: '',  //签名日期 年
              //     month: '',  //签名日期 月
              //     day: '',  //签名日期 日
              // },
            } = res.result;
            this.proposalData = {
              paper_plan_student_id,  //学生毕业设计及答辩id
              title,  //题目
              background,  //选题背景
              now_situation,  //国内外现状
              main_content,  //主要内容
              plan_content,  //方案与计划
              reference,  //参考文献
              open_time,  //开题时间
              open_place,  //开题地点
              open_participant,  //开题参与人员
              work_record,  //工作记录
              student_sign_img,  //学生手写签名
              student_sign_date,  //学生手写签名日期
              studentSignDate: (() => {
                  if(student_sign_date){
                      const [year, month, day] = student_sign_date.split('-');
                      return {
                          year,
                          month,
                          day,
                      };
                  } else {
                      return {
                          year: '',  //签名日期 年
                          month: '',  //签名日期 月
                          day: '',  //签名日期 日
                      };
                  }
              })(),
              // studentSignDate: {
              //     year: '',  //签名日期 年
              //     month: '',  //签名日期 月
              //     day: '',  //签名日期 日
              // },
              agree_open,  //是否同意开题 0否 1是
              teacher_opinion,  //指导老师意见
              teacher_sign_img,  //指导老师手写签名
              teacher_sign_date,  //指导老师手写签名日期
              teacherSignDate: (() => {
                if(teacher_sign_date){
                      const [year, month, day] = teacher_sign_date.split('-');
                      return {
                          year,
                          month,
                          day,
                      };
                  } else {
                      return {
                          year: '',  //签名日期 年
                          month: '',  //签名日期 月
                          day: '',  //签名日期 日
                      };
                  }
              })(),
              // teacherSignDate: {
              //     year: '',  //签名日期 年
              //     month: '',  //签名日期 月
              //     day: '',  //签名日期 日
              // },
            };
            resolve(true);
          }
        });
      });
    },
    // 弹窗 填写开题报告 提交
    proposalSubmit() {
      this.$refs["proposalRef"].validate((valid) => {
        if (valid) {
          // const data = deepClone(this.proposalData);
          const {
            paper_plan_student_id,  //学生毕业设计及答辩id
            title,  //题目
            background,  //选题背景
            now_situation,  //国内外现状
            main_content,  //主要内容
            plan_content,  //方案与计划
            reference,  //参考文献
            open_time,  //开题时间
            open_place,  //开题地点
            open_participant,  //开题参与人员
            work_record,  //工作记录
            student_sign_img,  //学生手写签名
            student_sign_date,  //学生手写签名日期
          } = this.proposalData;
          const data = {
            paper_plan_student_id,  //学生毕业设计及答辩id
            title,  //题目
            background,  //选题背景
            now_situation,  //国内外现状
            main_content,  //主要内容
            plan_content,  //方案与计划
            reference,  //参考文献
            open_time,  //开题时间
            open_place,  //开题地点
            open_participant,  //开题参与人员
            work_record,  //工作记录
            student_sign_img,  //学生手写签名
            student_sign_date,  //学生手写签名日期
          };
          studentSubmitReport(data).then(res => {
            if (res.code == 200) {
              this.$message.success('提交成功');
              this.isShowProposal = false;
              this.getStudentPpsInfoData(); 
            }
          });
        } else {
          goFirstError();
        }
      });
    },
    //  点击开题报告
    proposalClick() {
      this.isShowProposalSubmit = false;
      this.proposalData.paper_plan_student_id = this.paper_plan_student_id;
      const date = this.getDate();
      this.proposalData.student_sign_date = `${date.year}-${date.month}-${date.day}`;
      this.proposalData.studentSignDate = {
        year: date.year,
        month: date.month,
        day: date.day,
      };
      this.isShowProposal = true;
    },
    // 弹窗 填写开题报告 关闭
    proposalClose() {
      this.proposalData = {
        paper_plan_student_id: '',  //学生毕业设计及答辩id
        title: '',  //题目
        background: '',  //选题背景
        now_situation: '',  //国内外现状
        main_content: '',  //主要内容
        plan_content: '',  //方案与计划
        reference: '',  //参考文献
        open_time: '',  //开题时间
        open_place: '',  //开题地点
        open_participant: '',  //开题参与人员
        work_record: '',  //工作记录
        student_sign_img: '',  //学生手写签名
        student_sign_date: '',  //学生手写签名日期
        studentSignDate: {
          year: '',  //签名日期 年
          month: '',  //签名日期 月
          day: '',  //签名日期 日
        },
        agree_open: '',  //是否同意开题 0否 1是
        teacher_opinion: '',  //指导老师意见
        teacher_sign_img: '',  //指导老师手写签名
        teacher_sign_date: '',  //指导老师手写签名日期
        teacherSignDate: {
            year: '',  //签名日期 年
            month: '',  //签名日期 月
            day: '',  //签名日期 日
        },
      };
      if(this.$refs['esignHandle4']){
        this.$refs['esignHandle4'].handleReset();  //签名这块清空
      }
      this.$nextTick(() => {
        this.$refs['proposalRef'].clearValidate();
      });
    },
    // 获取毕设学生详情
    getStudentPpsInfoData() {
      const data = {
        paper_plan_student_id: this.paper_plan_student_id,
      };
      studentPpsInfo(data).then(res => {
        if (res.code == 200) {
          this.studentInfo = res.result;
        }
      });
    },
    // 获取年月日
    getDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return {
        year,
        month,
        day,
      };
    },
    // 弹窗 签名成回调
    studentSignImgAfter(v, refName, field) {
      this.$refs[refName].validateField(field);
    },
    // 获取数据
    getListFn(){
        const data = {
          paper_plan_student_id: this.paper_plan_student_id,
        }
        getReportList(data).then(res => {
            this.list = res.result;
        });
    },
  },
  beforeDestroy() {

  },
};
</script>

<style lang="scss" scoped>
@mixin floorBotStyle() {
  .floor-bot {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & + .floor-bot {
      margin-top: 0;
    }

    .el-form-item {
      width: 50%;
    }

    .date-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .input {
        input {
          width: 50px;
          border: none;
          text-align: center;
          padding: 0;
        }

        &:nth-child(1) {
          input {
            width: 60px;
          }
        }
      }

      .text {
        &.value {
          display: inline-block;
          width: 50px;
          text-align: center;
        }
      }
    }
  }
}
@mixin assignmentContStyle() {
  border: 1px solid #ccc;

    .floor {
      &.border-b {
        border-bottom: 1px solid #ccc;
      }

      .required::before {
        content: '*';
        color: #EF3333;
        margin-right: 4px;
      }

      .cont-title {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        height: 60px;
        line-height: 60px;
      }

      .border-r {
        border-right: 1px solid #ccc;
      }

      &.info-box {
        display: flex;
        height: 40px;
        line-height: 40px;

        .item {
          flex: 1;
          padding: 0 10px;

          .name,
          .value {
          }
        }
      }

      .item-title {
        padding: 0 10px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
      }

      &.textarea {
        padding: 0 10px;

        .el-textarea {
          padding-bottom: 20px;

          .el-textarea__inner {
            border: none;
            /*隐藏滚动条*/
            &::-webkit-scrollbar {
              display: none;
            }
          }
        }
      }

      &.table {
        .table-cont {
          padding: 10px;

          .table-box {
            width: 100%;

            .cell {
              padding: 10px 5px;
              text-align: center;

              &.week {
                width: 80px;
              }

              &.cont {

              }

              &.operate {
                width: 140px;
              }

              &.time{
                width: 100px;
              }

              &.time-value {
                width: 200px;
              }

              &.left{
                text-align: left;
              }

              @include floorBotStyle();

              .radio-box {
                display: flex;

                .el-form-item {
                  width: 100%;

                  .el-form-item__content {
                    text-align: left;

                    .el-radio {
                      margin-right: 100px;

                      &:last-child {
                        margin-right: 0;
                      }

                      // .el-radio__input{
                      //     &.is-checked{
                      //         .el-radio__inner{
                      //             background-color: #fff;
                      //         }
                      //     }
                      //     .el-radio__inner{
                      //         border-radius: 0;
                      //         &::after {

                      //         }
                      //     }
                      // }
                    }
                  }
                }
              }
            }

          }
        }

        table, th, td {
          border: 1px solid #ccc;
          border-collapse: collapse; /* 移除单元格之间的间隔 */
        }
      }

      &.bot {
        display: flex;
        justify-content: space-between;
        padding: 10px;

        .item {
          width: 48%;
        }
      }
    }
}
.openingReport {
    min-height: $contentH;
	padding: $sideMargin;
	padding-bottom: 0;
  .cont-box{
    background: $white;
    min-height: inherit;
    padding: 0 20px 20px;
  }
  // 填写开题报告
  .assignment {
    .cont {
      @include assignmentContStyle();
    }
  }
}
.proposalPDF-box{
  .assignment-pdf-cover {
    //height: 780px;
    min-height: 760px;
  }
  .title-box{
    .title1{
      font-size: 36px;
      text-align: center;
      font-weight: bold;
    }
    .title2{
      font-size: 24px;
      text-align: center;
    }
  }
  .el-form-item__content {
    line-height: normal;
  }
  .cover-box{
    width: 400px;
    margin: 0 auto;
    margin-top: 200px;
    .item{
      display: flex;
      height: 50px;
      & + .item{
        margin-top: 10px;
      }
      .name{
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
      }
      .value{
        width: calc(100% - 100px);
        font-size: 18px;
        border-bottom: 1px solid #999;
        display: flex;
        align-items: center;
      }
    }
  }
  .proposalPDF{
    margin-top: 400px;
    @include assignmentContStyle();
    .el-radio__input{
      &.is-disabled{
        &.is-checked{
          .el-radio__inner{
            &::after {
                background-color: #C0C4CC;
            }
          }
        }
      }
      .el-radio__inner{
        position: relative;
        &::after {
          content: '';
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 100%;
          background-color: #FFF;
          position: absolute;
          left: calc(50% - 2px);
          top: calc(50% - 2px);
          transform: scale(0);
          // left: 50%;
          // top: 50%;
          // transform: translate(-50%, -50%) scale(0);
          transition: transform .15s ease-in;
        }
      }
      &.is-checked{
        .el-radio__inner{
          &::after {
              // transform: translate(-50%, -50%) scale(1);
              transform: scale(1);
          }
        }
      }
    }
  }
}
</style>
